import { render, staticRenderFns } from "./AssemblyOrderForm.vue?vue&type=template&id=5a8e1490&scoped=true"
import script from "./AssemblyOrderForm.vue?vue&type=script&lang=js"
export * from "./AssemblyOrderForm.vue?vue&type=script&lang=js"
import style0 from "./AssemblyOrderForm.vue?vue&type=style&index=0&id=5a8e1490&prod&scoped=true&lang=css"
import style1 from "./AssemblyOrderForm.vue?vue&type=style&index=1&id=5a8e1490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e1490",
  null
  
)

export default component.exports